export const SortType = {
  Asc: 'Asc',
  Desc: 'Desc',
} as const;
export type SortType = (typeof SortType)[keyof typeof SortType];
